import * as types from "../action/types";

const initialState = {
  data: { items: [] },
  loading: false,
  error: null,
};

const feedbackByOfficerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FEEDBACK_BY_OFFICER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FEEDBACK_BY_OFFICER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.FETCH_FEEDBACK_BY_OFFICER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    default:
      return state;
  }
};

export default feedbackByOfficerReducer;
